import type { GQL_ID } from '@@partner:types:graphql'
import type { Banner } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_BANNERS_FIELDS } from '@@partner:graphql/shortcuts'

export interface BannerInfoInput {
  id?: GQL_ID
  file_id?: GQL_ID
  mobile_file_id?: GQL_ID
  name: string
  status: number
  optionOpenInNewWindow: boolean
  optionOpenInBrowser: boolean
}

export interface SaveBanner {
  bannerInfo: Banner
}
export interface SaveBannerVariables {
  newData: BannerInfoInput
  upsert?: boolean
}

export const GQL_MUTATION_SAVE_BANNER = gql`
  mutation($newData: BannerInfoInput!, $upsert: Boolean!) {
    bannerInfo: updateBannerInfo(newData: $newData, upsert: $upsert) {
      ${SHORTCUT_BANNERS_FIELDS}
    }
  }
`

export const useMutateSaveBanner = () =>
  useMutation<SaveBanner, SaveBannerVariables>(
    GQL_MUTATION_SAVE_BANNER
  )
